import { render, staticRenderFns } from "./RegisterView.vue?vue&type=template&id=ad795bbc&scoped=true"
import script from "./RegisterView.vue?vue&type=script&lang=ts"
export * from "./RegisterView.vue?vue&type=script&lang=ts"
import style0 from "./RegisterView.vue?vue&type=style&index=0&id=ad795bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad795bbc",
  null
  
)

export default component.exports